<ng-container *ngIf="definition as version">
  <button
    uiButton
    [text]="true"
    [outlined]="false"
    type="button"
    class="workflow-catalog-cell__primary workflow-catalog-cell__open"
    [attr.title]="title + ' · ' + version.workflowCode"
    [attr.aria-label]="
      'Open ' + title + ', version ' + version.definitionVersionCode
    "
    (click)="open()"
  >
    <span>{{ title }}</span>
  </button>
  <span
    *ngIf="title !== version.workflowCode"
    class="workflow-catalog-cell__secondary"
    [attr.title]="version.workflowCode"
    >{{ version.workflowCode }}</span
  >
</ng-container>
